// extracted by mini-css-extract-plugin
export default {"list":"List_list__469Om","panel":"List_panel__1A0Xa"};